import React from 'react';
import './Home.css';
import m5 from '../../Assets/images/209.jpeg'
import { Link } from 'react-router-dom';

function LastBanner() {

  return (
     <div className="bg-image" style={{ backgroundImage: `url(${m5})`, marginBottom:'70px' }}>
        <div className="hero-overlay bg-opacity-30">
            
        </div>
            <div className="hero-content text-center text-neutral-content">
                 <div style={{marginTop:"-450px"}}>
                    <h1 style={{fontFamily:'raleway'}}className="mb-5 text-3xl lg:text-6xl font-bold">“Education is the passport to the future, for tomorrow belongs to those who prepare for it today.” —Malcolm X</h1>
                    {/* <Link to='/development'><button style={{borderRadius:'0px'}} className="btn btn-outline btn-info px-12">Contribute Now</button></Link> */}
                 </div>
            </div>
     </div>
      
  )
}

export default LastBanner